import React, { useState } from 'react';
import { Alert } from 'react-bootstrap';
import { toast, ToastContainer } from 'react-toastify';
import saveAs from 'file-saver';

import { Waiting } from '../../../common/components/Waiting/Waiting';
import { useSpdCore } from '../../../common/hooks/useSpdCore';
import { Filter, FilterReportData } from '../RegistersView/Filter';
import { responseErrors } from '../../../common/spdCore/validation/responseErrors';
import { Role } from '../../../common/spdCore/authorization/roles';
import { ResponseError } from '../../../common/spdCore/autogenerated/spdApiClient';

export const DownloadsFilesView: React.FC = () => {
  const spd = useSpdCore();
  const [waiting, setWaiting] = useState<boolean>(false);
  const [alert, setAlert] = useState<string>('');

  const onSearch = async (filter: FilterReportData) => {
    setAlert('Pobieranie danych, proszę czekać...');
    setWaiting(true);
    const currentDate = new Date().toISOString().split('T')[0];
    spd.downloadsFiles
      .downloadFilesCompanySummary(`Dokumenty`, {
        ...filter,
        withExamined: true,
      })
      .then(blob => {
        if (blob) {
          saveAs(blob, `Dokumenty_${currentDate}.zip`);
          setWaiting(false);
        }
      })
      .catch(async response => {
        const err = await responseErrors(response as ResponseError);
        toast.error(err?.[0]);
        setWaiting(false);
      });
  };

  return (
    <>
      <ToastContainer />
      <Filter
        onSearch={onSearch}
        headerName={'Pobieranie dokumentów'}
        withUser={true}
        withDate={true}
        withEndStartDate={true}
        withHealthcareFacility={true}
        withRegister={true}
        withArticles={true}
        emptyOnStart={true}
        withCompany={true}
        canClean={true}
        requiredCompany={false}
        withDocumentsKind={true}
        userName={'Pracownik'}
        roles={[
          Role.PsychologistAssessor,
          Role.PsychologistSpecialist,
          Role.MedicalAssessor,
          Role.MedicalSpecialist,
          Role.Laryngologist,
          Role.Neurologist,
          Role.Ophthalmologist,
          Role.Psychiatrist,
        ]}
      />
      {waiting && (
        <>
          <Alert variant="warning">{alert}</Alert>
          <Waiting />
        </>
      )}
    </>
  );
};
